import { useFormik } from 'formik';
import { errorToastMessage } from '../../components/layout/toast-root/toast';
import { getSignInFormValidation } from './FormikData';
import { FirebaseErrorCodes } from '../../shared/constants';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../shared/paths';
import { useTranslation } from 'react-i18next';

export function useSignInPage() {
  const { logInWithPassword } = useFirebaseAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getSignInFormValidation(t),
    initialValues: { email: '', password: '' },
    onSubmit,
  });

  async function onSubmit(values: { email: string; password: string }) {
    try {
      await logInWithPassword({
        email: values.email,
        password: values.password,
      });

      navigate(Paths.root);
    } catch (error: any) {
      console.error('Register error message: ', error);
      if (FirebaseErrorCodes.includes(error.code)) {
        errorToastMessage(t(`error.${error.code}`));

        return;
      }
      errorToastMessage(t('error.somethingWentWrong'));
    }
  }

  return { formik };
}
